<template>
    <div class="shop-shared">
        <van-nav-bar
            :title="vipId>0?'店铺二维码':'分享店铺'"
        />
        <van-cell v-if="vipId>0?false:true" title="当前店铺：" is-link arrow-direction="down" :value="followShop.name" @click="cellClick()" />
        <van-action-sheet v-model="shopShow" :round="false" :actions="shopList" @select="onShopSelect" />
        <shopqr :qr_url="followShop.src" :shop_name="followShop.name" :shop_tel="followShop.shop_tel" :shop_address="followShop.shop_address" />
        <!-- <div class="shop-qr">
            <van-image width="100%" height="100%" :src="followShop.src" class="qr-image" />
            <van-image src="https://public.qiniu.xcims.com/logo.png" class="logo-water" />
        </div>
        <van-cell v-if="vipId>0?false:true" title="点击右上方分享按钮，可以把店铺二维码分享给好友。"  /> -->
    </div>
</template>

<script>
import { NavBar, Image as VanImage, Cell, ActionSheet, Toast  } from 'vant'
import { UserShopInfoApi, ShopQRCodeApi } from '@/api/shop'
import shopqr from '@/view/shop/components/shopqr'
import wxshare from "@/utils/wxshare"
import { toErrorPage } from '@/utils/usePage'

export default {
    components: {
        [NavBar.name]: NavBar,
        [VanImage.name]: VanImage,
        [Cell.name]: Cell,
        [ActionSheet.name]: ActionSheet,
        [Toast.name]: Toast,
        shopqr
    },
    data() {
        return {
            vipId: this.$route.params.vipId,
            shopList:[],
            followShop:{
                id: null,
                shop_id: null,
                name: "",
                shop_address: '',
                shop_tel: '',
                vip: null,
                follow: null,
                src: null
            },
            shopShow:false,
            img:null
        }
    },
    mounted() {
        if(this.vipId&&this.vipId>0){
            this.getQRcodeData(this.vipId);
        }
        else{
            this.getShopInfo()
        }
    },
    methods: {
        getShopInfo() {
            var that = this
            that.axios.get(UserShopInfoApi, {params: {type:'follow'} }).then((ret) => {
                console.log('getShopInfo')
                console.log(ret)
                if (ret.flag) {
                    ret = ret.details
                    that.shopList = []
                    ret.forEach(item => {
                        that.shopList.push({
                            id: item.id,
                            shop_id: item.shop_id,
                            name: item.name,
                            vip: item.vip,
                            follow: item.follow
                        })
                    })
                    that.shopList.forEach(item => {
                        if(item.follow){
                            that.followShop = item
                            this.getQRcodeData(item.vip)
                            return
                        }
                    });
                    that.overrideWeChatShare()
                } else {
                    toErrorPage(that,'',ret.info,'')
                    // Toast(ret.info)
                }
            }).catch(function (error) {
                console.log(error)
            })
        },
        overrideWeChatShare(){  //重写微信分享朋友圈和分享朋友方法
            // let obj={
            //     title:`您的好友正在分享${this.followShop.name}`,
            //     des:`扫描二维码即可关注微信店铺信息`,
            //     linkurl: `${window.location.origin}/#/nt/shop/shareshop/${this.vipId>0?this.vipId:this.followShop.vip}`,//分享链接
            // }
            // wxshare.getJSSDK()
            // wxshare.overrideWXShare(obj)
            wxshare.shareItem(`您的好友正在分享${this.followShop.name}`,
                '扫描二维码即可关注微信店铺信息',
                null,
                `${window.location.origin}/#/nt/shop/shareshop1/${this.vipId>0?this.vipId:this.followShop.vip}`)
        },
        cellClick(){
            this.shopShow = true
        },
        onShopSelect(item){
            this.shopShow = false
            this.followShop = item
            this.getQRcodeData(item.vip)
            this.overrideWeChatShare()
        },
        getQRcodeData(vipId) {    //获取店铺二维码方法
            var that = this
            that.axios.get(ShopQRCodeApi, {params: { type:'vipshare', vip_id: vipId } }).then((ret) => {
                console.log('getQRCodeData')
                console.log(ret)
                // that.followShop.src = ret.src;
                that.followShop.shop_tel = ret.shop_tel
                that.followShop.shop_address = ret.shop_address
                this.$set(that.followShop,'src',ret.src)
            }).catch(function (error) {
                console.log(error)
            })
        }
    }
}
</script>

<style lang="less" scoped>
// .shop-shared {

//     // .shop-qr {
//     //     display: flex;
//     //     align-items:center;
//     //     justify-content:center;

//     //     .qr-image {
//     //         z-index: 0;
//     //     }

//     //     .logo-water {
//     //         z-index: 9999;
//     //         width: 60px;  /* Or whatever */
//     //         height: 60px; /* Or whatever */
//     //         margin: auto;  /* Magic! */
//     //         // opacity: 0.5;
//     //         position: absolute;
//     //     }
//     // }
// }
</style>